import { lazy } from 'react';
/** Открывает карточку политики */
export const PolicyDetailsPageAsync = lazy(() => import('./PolicyDetails/PolicyDetailsPage'));